var tagText = 'fx_e395032e_lz3zmx1';
var tagTextColor = 'var(--fx_e395032e_lz3zmx0)';

export { tagText, tagTextColor };
//# sourceMappingURL=text.vanilla.mjs.map
